const translations = {
  discard: 'Discard',
  back: 'Back',
  next: 'Next',
  skip: 'Skip',
  save: 'Save',
  close: 'Close',
  publish: 'Publish',
  download: 'Download',
  download_documents: 'Download documents',
  cancel: 'Cancel',
  export: 'Export',
  new: 'New',
  add: 'Add',
  add_vehicle: 'Add vehicle',
  go_back: 'Go back',
  activate: 'Activate',
  expire: 'Expire',
  confirm: 'Confirm',
  change: 'Change',
  remove: 'Remove',
  delete: 'Delete',
  disable: 'Disable',
  enable: 'Enable',
  upload: 'Upload',
  update: 'Update',
  details: 'Details',
  select: 'Select',
  current: 'Current',
  edit: 'Edit',
  view: 'View',
  copy: 'Copy',
  actions: 'Actions',
  refresh: 'Refresh',
  search: 'Search',
  search_by_name_or_id: 'Search by name or id',
  import: 'Import',
  upgrade: 'Upgrade',
  create: 'Create',
  restore: 'Restore',
  try_again: 'Try again',
  keep: 'Keep',
  add_new: 'Add new',
  pricing_analytics: 'Pricing Insights',
  replace: 'Replace',
  delete_selected: 'Delete selected',
  continue: 'Continue',
  reject_and_logout: 'Reject and log out',
  config: 'Config',
  include_all: 'Include all',
  exclude_all: 'Exclude all',
  remove_all: 'Remove all',
  total: 'Total',
  category: 'Category',
  price: 'Price',
  filters: 'Filters',
};

export default translations;
